"use client";

import React from "react";
import { Card, CardHeader, CardContent } from "@/components/ui/card";

export default function ProfileEditFormSkeleton() {
  return (
    <section>
      <Card className="max-w-3xl mx-auto">
        <CardHeader className="py-0">
          <div className="sticky top-[64px] z-20 -mx-6 px-6 py-2 bg-background/80 backdrop-blur border-b border-border flex items-center justify-between">
            <div className="h-9 w-20 skeleton rounded" />
            <div className="h-9 w-24 skeleton rounded" />
          </div>
        </CardHeader>
        <CardContent className="space-y-6 pt-6">
          {/* Stage name */}
          <div className="space-y-2">
            <div className="h-4 w-28 skeleton rounded" />
            <div className="h-10 w-full skeleton rounded" />
          </div>

          {/* Height & Weight sliders */}
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
            <div className="space-y-2">
              <div className="h-4 w-36 skeleton rounded" />
              <div className="h-4 w-full skeleton rounded" />
            </div>
            <div className="space-y-2">
              <div className="h-4 w-36 skeleton rounded" />
              <div className="h-4 w-full skeleton rounded" />
            </div>
          </div>

          {/* Select rows (Sex/Ethnicity, Body Type) */}
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
            {Array.from({ length: 2 }).map((_, i) => (
              <div key={`sel-${i}`} className="space-y-2">
                <div className="h-4 w-24 skeleton rounded" />
                <div className="h-10 w-full skeleton rounded" />
              </div>
            ))}
          </div>

          {/* Multi-select (skills) */}
          <div className="space-y-2">
            <div className="h-4 w-20 skeleton rounded" />
            <div className="h-10 w-full skeleton rounded" />
          </div>

          {/* Large textarea */}
          <div className="space-y-2">
            <div className="h-4 w-32 skeleton rounded" />
            <div className="h-28 w-full skeleton rounded" />
          </div>
        </CardContent>
      </Card>
    </section>
  );
}
